export const SAVE_USER_TOKEN = 'SAVE_USER_TOKEN';
export const EMAIL_EXIST = 'EMAIL_EXIST';
export const GET_COUNTRY = 'GET_COUNTRY';
export const GET_CITY = 'GET_CITY';
export const SAVE_IMAGE = 'SAVE_IMAGE';
export const HANDLE_DIALOG = 'HANDLE_DIALOG';
